import {MercuryQuery} from '../types/MercuryQuery';

export class MercuryQueryHelpers {
  public static hash(query: MercuryQuery) {
    return JSON.stringify(query);
  }
}
